
const link = document.createElement('link');
link.setAttribute('rel', 'stylesheet');
link.setAttribute('type', 'text/css');
link.setAttribute(
	'href', 
	Liferay.ThemeDisplay.getPathContext() + '/o/dynamic-data-mapping-form-field-type/Validation/CustomDate.css'
);
document.querySelector('head').appendChild(link);
